import type {
  UploaderFile,
  UploaderFileListRenderProps,
  UploaderMeta,
} from '../types';
import type Uppy from '@uppy/core';
import type { Meta } from '@uppy/core';
import type { ReactNode } from 'react';

import { useUppyState } from '@uppy/react';

import { UppyFilesList } from './UppyFilesList';

type P<TMeta extends UploaderMeta> = {
  isDisabled: boolean;
  renderFileList?: (props: UploaderFileListRenderProps<TMeta>) => ReactNode;
  uppy: Uppy<Meta, Record<string, never>>;
};

export function UploaderFileList<TMeta extends UploaderMeta>({
  isDisabled,
  renderFileList,
  uppy,
}: P<TMeta>) {
  const files = useUppyState(uppy, (state) =>
    Object.values(state.files),
  ) as UploaderFile<TMeta>[];

  if (!renderFileList) {
    return (
      <UppyFilesList
        className="uploader-file-list mt-2 max-h-56"
        isDisabled={isDisabled}
        uppy={uppy}
      />
    );
  }

  return renderFileList({
    files,
    isDisabled,
    removeFile: (fileId) => {
      if (isDisabled) return;
      uppy.removeFile(fileId);
    },
    setFileMeta: (fileId, fileMeta) => {
      if (isDisabled) return;
      const file = uppy.getFile(fileId);
      uppy.setFileMeta(fileId, { ...file.meta, ...fileMeta });
    },
  });
}
